<template>
  <fragment>
    <app-header :title="mediaOwner.name"/>
    <slot name="nav"/>

    <div class="container container-max-md">
      <form class="card" @submit.prevent>
        <validation-observer
          tag="div"
          class="card-body card-body-lg d-flex flex-column"
          @submit.native.prevent
          ref="validation"
        >
          <h2 class="card-title">Features Settings</h2>
          <p>Control features that are enabled for this media owner</p>

          <div v-for="(features, group) in featureGroups" :key="group" class="mb-4">
            <h4 class="mb-3">{{ features[0].group_title }}</h4>

            <validation-provider
              v-for="feature in features"
              :key="feature.id"
              :name="feature.key"
              class="row align-items-center mb-3"
            >
              <div class="col-12 col-md-4">
                <p class="mb-0 fw-normal">{{ feature.name }}</p>
              </div>
              <div class="col-12 col-md-8">
                <c-input
                  as="multiselect"
                  :value="getFeatureValue(feature)"
                  :options="options"
                  :preselect-first="true"
                  label="name"
                  track-by="value"
                  @input="setFeatureValue(feature, $event)"
                  :show-labels="false"
                  :allow-empty="false"
                />
              </div>
              <c-help-block/>
            </validation-provider>
          </div>

          <div class="text-end mt-auto">
            <c-button @click="handleSave" variant="primary" validate>
              Save Changes
            </c-button>
          </div>
        </validation-observer>
      </form>
    </div>
  </fragment>
</template>

<script>
import { get, call } from 'vuex-pathify'
import { stateMapper } from '@/vuex/modules/media-owners'
import {
  helperComputed as helperComputedFeature,
  helperMethods as helperMethodsFeature
} from '@/vuex/modules/media-owners/features'
import { toast } from '@chameleon/chameleon-vue'
import { http } from '@/utils'
import { groupBy } from 'lodash'

export default {
  mixins: [stateMapper],
  components: {},

  async created () {
    await this.getFeatures()

    this.localDisabledFeatures = this.features.reduce((acc, feature) => {
      const isEnabled = feature.enabled ? this.options[0] : this.options[1]
      acc[feature.id] = this.stateDisabledFeatures.includes(feature.key)
        ? this.options[1]
        : isEnabled
      return acc
    }, {})
  },

  data () {
    return {
      options: [
        { value: 'on', name: 'On' },
        { value: 'off', name: 'Off' }
      ],
      localDisabledFeatures: {}
    }
  },

  computed: {
    ...get('mediaOwners', ['mediaOwner']),
    ...helperComputedFeature,
    featureGroups () {
      return groupBy(this.features, 'group')
    }
  },

  methods: {
    ...call('mediaOwners', ['updateMediaOwner']),
    ...helperMethodsFeature,

    getFeatureValue (feature) {
      const isEnabled = feature.enabled ? this.options[0] : this.options[1]
      return this.localDisabledFeatures[feature.id] ?? isEnabled
    },

    setFeatureValue (feature, option) {
      this.localDisabledFeatures = {
        ...this.localDisabledFeatures,
        [feature.id]: option
      }
    },

    async handleSave () {
      const resource = await http.put(`media-owners/${this.mediaOwner.id}/features`, {
        features: Object.entries(this.localDisabledFeatures).map(([id, option]) => ({
          id: Number(id),
          enabled: option.value === 'on'
        }))
      })

      this.stateDisabledFeatures = (resource.data.data ?? []).filter(feature => !feature.enabled).map(feature => feature.key)

      toast('Media owner features updated', 'success')
    }
  }
}
</script>
